export default __webpack_public_path__ + "static/media/wegovy-check-dose.0f27ec31.mp4";